module.exports = __webpack_public_path__ + "static/media/ljubljana-29.5c2d067a.jpg";